import { atom } from 'recoil';

import { localStorageEffect } from 'utils/recoil';

import storage from '@/utils/storage1';

export const privateModeAtom = atom<boolean>({
  key: 'PrivateModeAtom',
  default: storage.private_mode || false,
  effects_UNSTABLE: [localStorageEffect('private_mode')],
});

const noop = (...args: any) => {};

export const usePrivate = () => {
  // return useRecoilState(privateModeAtom);

  return [false, noop] as const;
};
